import { Component, OnInit } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner'
import {ActivatedRoute} from '@angular/router'
import { CargoComponent } from './cargo/cargo.component'
import { Location } from '@angular/common';
import { CandidatoComponent } from './candidato/candidato.component'
import { CadastroEleicaoComponent } from 'src/app/pages/gestor/cadastro-eleicao/cadastro-eleicao.component'
import { CandidaturaService } from 'src/app/services/candidatura.service';


@Component({
  selector: 'app-parametrizacoes',
  templateUrl: './parametrizacoes.component.html',
  styleUrls: ['./parametrizacoes.component.css']
})
export class ParametrizacoesComponent implements OnInit {
  eleicaoParametrizacao: any;
  temIntegracao: any;
  enviaEmails: any;
  temCandidaturas: any;
  candidaturaId: any;

  constructor(
    public spinner: NgxSpinnerService,
    public router: ActivatedRoute,
    private location: Location,
    private eleCad: CadastroEleicaoComponent,
    protected candidaturaService: CandidaturaService
  ) { }

 async ngOnInit() {
    this.spinner.show();
    this.eleicaoParametrizacao = JSON.parse(sessionStorage.getItem("eleicaoClicadaParametrizacao"));
    if(this.eleicaoParametrizacao.acessoIntegracao != null && this.eleicaoParametrizacao.acessoIntegracao != false){
      this.temIntegracao = true;
      sessionStorage.setItem("temIntegracao", this.temIntegracao);
    }
    if(this.eleicaoParametrizacao.acessoIntegracao !=null &&   this.eleicaoParametrizacao.enviaEmails != false){
      this.temIntegracao = true;
      sessionStorage.setItem("enviaEmails", this.enviaEmails);
    }
    if(this.eleicaoParametrizacao.temCandidaturas != null && this.eleicaoParametrizacao.temCandidaturas != false ){
      this.temCandidaturas = true;
      sessionStorage.setItem("temCandidaturas", this.temCandidaturas);
      this.listarDadosExistentes();
    }
    this.spinner.hide();
  }

async listarDadosExistentes(){
  await this.candidaturaService.listarPorIdEleicao(this.eleicaoParametrizacao.id, sessionStorage.getItem("token")).then((data: any) => {
    sessionStorage.setItem("candidaturaId", data.id);
    }, err => {
      console.log(err);
    })
  }


  voltar(){
    sessionStorage.removeItem("eleicaoClicadaParametrizacao");
    sessionStorage.removeItem("temCandidaturas");
    sessionStorage.removeItem("temIntegracao");
    sessionStorage.removeItem("enviaEmails");
    sessionStorage.removeItem("candidaturaId");
    this.location.back();
  }
}
